/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { userSetupHeaderStyles } from "@monsma/Overrides/Widgets/UserSetup/UserSetupHeader";
import { screen } from "@monsma/XDL/Helpers";
import { css } from "styled-components";

userSetupHeaderStyles.titleGridItem = {
    width: [9, 8, 7, 7, 7],
};

userSetupHeaderStyles.actionsGridItem = {
    width: [3, 4, 5, 5, 5],
    css: css`
        justify-content: flex-end;
    `,
};

userSetupHeaderStyles.saveButton = {
    css: css`
        ${screen("only", "sm")} {
            margin-right: 15px;
        }
    `,
};
